// extracted by mini-css-extract-plugin
export default {"statusBadge":"styles_statusBadge__-rRoJ","statusContainer":"styles_statusContainer__x12Ui"};